import PropTypes from "prop-types";
import React, { useState } from "react";

const humanSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const extensionOf = (filename) =>
  (filename.split(".").pop() || "plik").toUpperCase().slice(0, 4);

const Documents = (props) => {
  // React 19 ignores defaultProps on function components - default here instead.
  const { documents, title = "Materiały" } = props;

  // Folded by default - the lesson is the focus, documents are there when wanted.
  const [open, setOpen] = useState(false);

  // Courses without documents show nothing at all - no empty state.
  if (!documents || documents.length === 0) return null;

  const rows = documents.map((document) => (
    <tr key={document.id} className="border-b border-gray-100 last:border-b-0">
      <td className="py-2 sm:py-3 pr-3 sm:pr-4">
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="w-8 h-6 sm:w-9 sm:h-7 shrink-0 border border-gray-200 flex items-center justify-center text-[9px] font-bold text-gray-500">
            {extensionOf(document.filename)}
          </span>
          <span className="font-medium">{document.title}</span>
        </div>
      </td>
      <td className="py-2 sm:py-3 pr-3 sm:pr-4 text-gray-500 hidden md:table-cell">
        {document.filename}
      </td>
      <td className="py-2 sm:py-3 pr-3 sm:pr-4 text-gray-500 whitespace-nowrap">
        {humanSize(document.byte_size)}
      </td>
      <td className="py-2 sm:py-3 text-right whitespace-nowrap">
        <a
          href={document.download_url}
          className="font-semibold text-primaryYellow hover:underline"
        >
          Pobierz
        </a>
      </td>
    </tr>
  ));

  return (
    <div className="w-full bg-white border border-gray-200">
      <button
        className="w-full flex justify-between items-center px-3 py-2 sm:px-4 sm:py-3 border-b border-gray-200"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="text-sm sm:text-base font-semibold">{title}</span>
        <span className="flex items-center gap-2 text-xs text-gray-500">
          {documents.length}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className={`size-4 transition-transform ${open ? "" : "-rotate-90"}`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
          </svg>
        </span>
      </button>

      {open && (
        <div className="overflow-x-auto px-3 sm:px-4">
          <table className="w-full text-xs sm:text-sm text-left">
            <thead>
              <tr className="text-xs text-gray-500 border-b border-gray-200">
                <th className="py-2 pr-3 sm:pr-4 font-medium">Nazwa</th>
                <th className="py-2 pr-3 sm:pr-4 font-medium hidden md:table-cell">
                  Plik
                </th>
                <th className="py-2 pr-3 sm:pr-4 font-medium">Rozmiar</th>
                <th className="py-2 font-medium text-right">Pobierz</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};

Documents.propTypes = {
  documents: PropTypes.array,
  title: PropTypes.string,
};

export default Documents;
